import React from 'react'
import { cn } from '../../../utils/classnames'

const SecondaryButton = ({
  disabled = false,
  children,
  icon: Icon,
  loading = false,
  loadingText = null,
  className = '',
  ...props
}) => {
  const isDisabled = loading || disabled

  return (
    <button
      disabled={isDisabled}
      {...props}
      className={cn(
        'px-6 py-3 rounded-xl text-sm font-semibold transition duration-200 items-center flex gap-2 justify-center',
        isDisabled
          ? 'bg-gray-100 text-gray-400 opacity-50 border-r-2 border-b-2 border-gray-300 cursor-not-allowed'
          : 'bg-blueUltraLight text-grayDark hover:opacity-80 border-r-2 border-b-2 border-graySemiDark',
        className
      )}
    >
      {loading && (
        <svg className="animate-spin h-4 w-4 text-gray-600" viewBox="0 0 24 24">
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>
      )}
      {Icon && <Icon size={16} strokeWidth={2} />}
      {loading ? (loadingText || children) : children}
    </button>
  )
}

export default SecondaryButton
